<div class="delivery-details-container">
  <!-- Product Information -->
  <div class="product-info-section">
    <h3 class="section-title">
      <i class="product-icon icon pi pi-box"></i>
      {{ '::DeliveryGift:Information:Title' | abpLocalization }}
    </h3>

    <div class="product-details">
      <div class="product-image">
        <img *ngIf="productImage" [src]="productImage" alt="Product" />
        <div *ngIf="!productImage" class="placeholder-image"></div>
      </div>
      <div class="product-info">
        <div class="product-name" pTooltip="{{ productName }}">{{ productName }}</div>
        <div class="delivery-info-row">
          <i class="icon pi pi-truck"></i>
          <span class="info-label">{{
            '::Delivery:EstimatedDeliveryDate:Label' | abpLocalization
          }}</span>
          <span class="info-value">{{ expectedDeliveryDate | Date }}</span>
        </div>
        <div class="delivery-info-row">
          <i class="icon pi pi-map-marker"></i>
          <span class="info-label">{{ '::Delivery:TrackingNumber:Label' | abpLocalization }}</span>
          <span class="info-value">{{ trackingNumber }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Delivery Status -->
  <div class="delivery-status-section">
    <app-delivery-step-progress [currentStepIndex]="currentStep"></app-delivery-step-progress>
  </div>

  <!-- Delivery Confirmation Section -->
  <div class="delivery-confirmation-section">
    <h3 class="section-title">
      {{ '::DeliveryGift:AboutReceiptConfirmation:Label' | abpLocalization }}
    </h3>

    <div class="notification-box">
      <div class="important-notice">
        {{ '::DeliveryGift:AboutReceiptConfirmation:Heading' | abpLocalization }}
      </div>
      <ul class="notice-list">
        <li>{{ '::DeliveryGift:AboutReceiptConfirmation:Content1' | abpLocalization }}</li>
        <li>{{ '::DeliveryGift:AboutReceiptConfirmation:Content2' | abpLocalization }}</li>
        <li>{{ '::DeliveryGift:AboutReceiptConfirmation:Content3' | abpLocalization }}</li>
      </ul>
    </div>

    <!-- Optional Fan Message -->
    <div class="fan-message-section">
      <h4 class="message-title">
        {{ '::DeliveryGift:MessageToFan:Label' | abpLocalization }}
      </h4>

      <textarea
        class="message-input"
        placeholder="{{ '::DeliveryGift:MessageToFan:PlaceHolder' | abpLocalization }}"
        [(ngModel)]="fanMessage"
        [maxlength]="200"
      >
      </textarea>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <p-button (click)="submitConfirmation()" styleClass="p-button-rounded w-100 button-content">
        <span>{{ '::DeliveryGift:Btn:Confirm' | abpLocalization }}</span>
      </p-button>
      <p-button
        (click)="closeDialog()"
        styleClass="p-button-outlined p-button-rounded cancel-button w-100"
      >
        <span>{{ '::DeliveryGift:Btn:Return' | abpLocalization }}</span>
      </p-button>
    </div>
  </div>
</div>
